import React from 'react';

import './styles.less';

const ZoomSliderLevel = ({ percentage }) => {
  const style = { width: percentage };

  return (
    <div className="thumb-zoom-level" style={style}>
      <span />
    </div>
  );
};

export default ZoomSliderLevel;
